<template>
  <textarea
    ref="textarea"
    class="form-control textarea-auto-resize"
    :value="modelValue"
    @input="handleInput"
    :placeholder="placeholder"
    :rows="minRows"
  ></textarea>
</template>

<script>
export default {
  name: 'TextareaInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    minRows: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.resize();
  },
  updated() {
    this.resize();
  },
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
      this.resize();
    },
    resize() {
      const textarea = this.$refs.textarea;
      if (!textarea) return;

      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.textarea-auto-resize {
  resize: none;
  overflow: hidden;
  min-height: auto;
}
</style>
